import type { ColorScheme } from '../types/user';

export function getThemeColors(scheme: ColorScheme) {
  switch (scheme) {
    case 'blue':
      return {
        stat1: 'from-blue-50 to-blue-100 dark:from-blue-950/50 dark:to-blue-900/50',
        stat1Text: 'text-blue-900 dark:text-blue-100',
        stat1Icon: 'bg-blue-200/50 dark:bg-blue-800/50 text-blue-700 dark:text-blue-300',
        stat2: 'from-blue-100 to-blue-150 dark:from-blue-900/50 dark:to-blue-800/50',
        stat2Text: 'text-blue-900 dark:text-blue-100',
        stat2Icon: 'bg-blue-300/50 dark:bg-blue-700/50 text-blue-800 dark:text-blue-200',
        stat3: 'from-blue-50 to-blue-100 dark:from-blue-950/50 dark:to-blue-900/50',
        stat3Text: 'text-blue-900 dark:text-blue-100',
        stat3Icon: 'bg-blue-200/50 dark:bg-blue-800/50 text-blue-700 dark:text-blue-300',
        stat4: 'from-blue-100 to-blue-150 dark:from-blue-900/50 dark:to-blue-800/50',
        stat4Text: 'text-blue-900 dark:text-blue-100',
        stat4Icon: 'bg-blue-300/50 dark:bg-blue-700/50 text-blue-800 dark:text-blue-200',
      };
    case 'slate':
      return {
        stat1: 'from-slate-50 to-slate-100 dark:from-slate-950/50 dark:to-slate-900/50',
        stat1Text: 'text-slate-900 dark:text-slate-100',
        stat1Icon: 'bg-slate-200/50 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300',
        stat2: 'from-slate-100 to-slate-150 dark:from-slate-900/50 dark:to-slate-800/50',
        stat2Text: 'text-slate-900 dark:text-slate-100',
        stat2Icon: 'bg-slate-300/50 dark:bg-slate-700/50 text-slate-800 dark:text-slate-200',
        stat3: 'from-slate-50 to-slate-100 dark:from-slate-950/50 dark:to-slate-900/50',
        stat3Text: 'text-slate-900 dark:text-slate-100',
        stat3Icon: 'bg-slate-200/50 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300',
        stat4: 'from-slate-100 to-slate-150 dark:from-slate-900/50 dark:to-slate-800/50',
        stat4Text: 'text-slate-900 dark:text-slate-100',
        stat4Icon: 'bg-slate-300/50 dark:bg-slate-700/50 text-slate-800 dark:text-slate-200',
      };
    case 'neutral':
      return {
        stat1: 'from-neutral-50 to-neutral-100 dark:from-neutral-950/50 dark:to-neutral-900/50',
        stat1Text: 'text-neutral-900 dark:text-neutral-100',
        stat1Icon:
          'bg-neutral-200/50 dark:bg-neutral-800/50 text-neutral-700 dark:text-neutral-300',
        stat2: 'from-neutral-100 to-neutral-150 dark:from-neutral-900/50 dark:to-neutral-800/50',
        stat2Text: 'text-neutral-900 dark:text-neutral-100',
        stat2Icon:
          'bg-neutral-300/50 dark:bg-neutral-700/50 text-neutral-800 dark:text-neutral-200',
        stat3: 'from-neutral-50 to-neutral-100 dark:from-neutral-950/50 dark:to-neutral-900/50',
        stat3Text: 'text-neutral-900 dark:text-neutral-100',
        stat3Icon:
          'bg-neutral-200/50 dark:bg-neutral-800/50 text-neutral-700 dark:text-neutral-300',
        stat4: 'from-neutral-100 to-neutral-150 dark:from-neutral-900/50 dark:to-neutral-800/50',
        stat4Text: 'text-neutral-900 dark:text-neutral-100',
        stat4Icon:
          'bg-neutral-300/50 dark:bg-neutral-700/50 text-neutral-800 dark:text-neutral-200',
      };
    case 'stone':
      return {
        stat1: 'from-stone-50 to-stone-100 dark:from-stone-950/50 dark:to-stone-900/50',
        stat1Text: 'text-stone-900 dark:text-stone-100',
        stat1Icon: 'bg-stone-200/50 dark:bg-stone-800/50 text-stone-700 dark:text-stone-300',
        stat2: 'from-stone-100 to-stone-150 dark:from-stone-900/50 dark:to-stone-800/50',
        stat2Text: 'text-stone-900 dark:text-stone-100',
        stat2Icon: 'bg-stone-300/50 dark:bg-stone-700/50 text-stone-800 dark:text-stone-200',
        stat3: 'from-stone-50 to-stone-100 dark:from-stone-950/50 dark:to-stone-900/50',
        stat3Text: 'text-stone-900 dark:text-stone-100',
        stat3Icon: 'bg-stone-200/50 dark:bg-stone-800/50 text-stone-700 dark:text-stone-300',
        stat4: 'from-stone-100 to-stone-150 dark:from-stone-900/50 dark:to-stone-800/50',
        stat4Text: 'text-stone-900 dark:text-stone-100',
        stat4Icon: 'bg-stone-300/50 dark:bg-stone-700/50 text-stone-800 dark:text-stone-200',
      };
  }
}
